import {
    CUSTOMERFACINGSURVEY_LOAD,
    CUSTOMERFACINGSURVEY_UNLOAD,
    CUSTOMERFACINGSURVEY_SETACCESSKEY
} from '../../../../actionDefinitions';
import { sendSurvey, fetchCustomerFacingSurvey_ } from './CustomerFacingSurveyApi';

export function unloadCustomerFacingSurvey() {
    return { type: CUSTOMERFACINGSURVEY_UNLOAD };
}

export function fetchCustomerFacingSurvey(key) {
    return dispatch => {
        return fetchCustomerFacingSurvey_(key)
            .then(payload => {
                dispatch({
                    type: CUSTOMERFACINGSURVEY_LOAD,
                    payload: {
                        survey: payload.survey,
                        surveyForms: payload.surveyForms,
                        logoLink: payload.logoLink
                        //customerLink: payload.link,
                        //customerEmail: payload.email
                    }
                });
            })
            .catch(payload => {
                dispatch({ type: CUSTOMERFACINGSURVEY_LOAD, error: true, payload });
            });
    };
}

export function setAccessKey(key) {
    return { type: CUSTOMERFACINGSURVEY_SETACCESSKEY, payload: key };
}

export function updateSurvey(survey) {
    return dispatch =>
        sendSurvey(survey)
            .then(payload => {
                const updatedSurvey = payload.Result;
                dispatch({ type: CUSTOMERFACINGSURVEY_LOAD, payload: { survey: updatedSurvey } });
            })
            .catch(payload => dispatch({ type: CUSTOMERFACINGSURVEY_LOAD, error: true, payload }));
}
